import React, { memo } from 'react';

const CARD_BLOCK = 'card';

const Card = ({ children }) => {
  return <div className={CARD_BLOCK}>{children}</div>;
};

export default memo(Card);
